import React, { useEffect, useState } from "react";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import Pagination from "../../../../Components/Utils/Pagenation";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import {  useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../../../Services/axiosCommon";
import * as yup from "yup";
import UseGetDataSearchByProUser from "../../../../Components/Hooks/useFetchDataByPROUser";
import { useFormik } from "formik";
import ClientManagementLayout from "../ClientManagementLayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import { NuDate } from "../../../../Components/Utils/Input";
import NuDateFormate from "../../../../Components/Utils/NuDate";

import SurveyReportCard from "./SurveyReportCard";
import MultiEditSR from "./MultiEditSR";
import ImportSurveyReport from "./ImportSurveyReport";
import MobileSRIndex from "../../../Mobile/ClientManage/SurveyReportMobile/MobileSRIndex";
import CloseIcon from "../../../../Components/Icons/Close";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import UseInspectorDD from "../../../../Components/Hooks/useInspectorSearch";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";






function SurveyReportIndex() {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });
  const [showFilterDialog, setShowFilterDialog] = useState(false);


  const { value: status, getData: refStatus } = useFetchMDIndex(
        `/dropdown/dropdown-details/`,
        "Status_Survey",showFilterDialog
      );

      const { data: user } = UseDropDown(`/user/drop-down`);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [searchClient, setSearchClient] = useState("");

  
const [open, setOpen] = useState(false);
const location = useLocation();
const state = location.state;
const { officeId } = useParams();
const currentPage = location.state?.currentPage;
const searchQuery = location.state?.searchQuery;
const [page, setPage] = useState(currentPage || 1);
const [pageCount, setPageCount] = useState(
localStorage.getItem("perPageView") || 20
);

const [filter, setFilter] = useState(state?.industry ? true : false);

const [filterProps, setFilterProps] = useState({

inspector:"",
inspectionDate:"",
});
const [params, setParams] = useState({
page: page,
per_page: pageCount,
status:"",
  assigneeId:"",
  dateFrom:"",
  dateTo:""
});
const clearFilter = () => {
setParams({
  ...params,
  status:"",
  assigneeId:"",
  dateFrom:"",
  dateTo:""
});
formik.values.status = "";
formik.values.assigneeId = "";
formik.values.dateFrom = "";
formik.values.dateTo = "";


setFilter(false);
};

const formik = useFormik({
enableReinitialize: true,
initialValues: filterProps,
validateOnChange: false,
validateOnBlur: false,
validationSchema: yup.object({
  // email: yup.string().required('Email is required!'),
}),
onSubmit: async (value, { resetForm }) => {
  console.log("ffff", value);
  setParams({ ...params,
    status: value.status, 
    assigneeId: value.assigneeId, 
    dateFrom: value.dateFrom, 
    dateTo: value.dateTo, 

    });
  closeFilterDialog();
  setFilter(true);
  setFilterProps({
    status:"",
    assigneeId:"",
    dateFrom:"",
    dateTo:""
  });
},
});
const { data,totalCount, getData, dataLoading } = UseGetDataSearch(
`/survey-report/list`,
params
);
console.log(data,"survey");

const [viewMode, setViewMode] = useState(
localStorage.getItem("viewMode") || "card"
);

console.log(data,"survey");


const defaultHeader = [
  {
    title: "Ref",
    width: "5%",
    field: "refNumber",
    isLink: true,
    id: "id",
    link: `/client-management/survey-report/view/`,
    textAlign: "center",
    rowAlign: "center",
  },
  // {
  //   title: "Client",
  //   width: "10%",
  //   isLink: true,
  //   id: "id",
  //   link: `/client-management/survey-report/view/`,
  //   field: "clientName",
  //   textAlign: "center",
  //   rowAlign: "center",
  // },

  {
    title: "Project ",
    width: "10%",
    field: "project",
    textAlign: "center",
    rowAlign: "center",
  },

  // {
  //   title: "Scope",
  //   width: "10%",
  //   field: "scope",
  //   textAlign: "center",
  //   rowAlign: "center",
  // },
  {
    title: "Location ",
    width: "10%",
    field: "location",
    textAlign: "center",
    rowAlign: "center",
  },
  {
    title: "Inspection Date ",
    width: "10%",
    type: "date",
    field: "inspectionDate",
    textAlign: "center",
    rowAlign: "center",
  },
  // {
  //   title: "Inspector ",
  //   width: "10%",
  //   field: "inspector",
  //   textAlign: "center",
  //   rowAlign: "center",
  // },

  
  {
    title: "Status ",
    width: "10%",
    field: "status",
    textAlign: "center",
    rowAlign: "center",
  },

  {
    title: "Action",
    width: "5%",
    field: "action",
    textAlign: "center",
    rowAlign: "center",
    contents: {
      fetcher:getData,
      id: "id",
      removeValue: "refNumber",
      url: `/survey-report/delete/`,
      moduleName: "SurveyReport",
      from: `/client-management/survey-report/`,
      editLink: `/client-management/survey-report/edit/`,
      viewLink: `/client-management/survey-report/view/`,
    },
  },
];
const availableHeaders = [
 
];
useEffect(() => {
localStorage.setItem("viewMode", viewMode);
setParams({ ...params, page: page, per_page: pageCount });
}, [page, pageCount, viewMode]);

const closeFilterDialog = () => {
setShowFilterDialog(false);
};
const [showImportModal, setShowImportModal] = useState(false);

const handleImportClick = () => {
setShowImportModal(true);
};

const closeModal = () => {
setShowImportModal(false);
};
const [showExport, setShowExport] = useState(false);
const [exportValue, setExportValue] = useState({
  status:"",
  assigneeId:"",
  dateFrom:"",
  dateTo:""
});
const ExportFormik = useFormik({
enableReinitialize: true,
initialValues: exportValue,
validateOnChange: false,
validateOnBlur: false,
onSubmit: async (value, { resetForm }) => {
  try {
    const response = await axiosInstance.get(
      `/survey-report/export?status=${value.status}&assigneeId=${value.assigneeId}&dateFrom=${value.dateFrom}&dateTo=${value.dateTo}`,
      {
        responseType: "blob",
      }
    );

    const pdfBlob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(pdfBlob);
    link.download = `Survey Report ${NuDateFormate({
      value: new Date(),
      format: "DD-MMM-YYYY",
    })}.xlsx`;

    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
  } catch (error) {
    console.error("Error downloading the PDF:", error);
  }
},
});
const closeFilterDialogebox = () => {
setShowExport(false);
};

const [showEdit, setShowEdit] = useState(false);
const [listofNumbers, setListofNumbers] = useState([]);
const [fullList, setFullList] = useState([]);

const selectOneFunction = (value) => {
console.log("sss", value);

let NewId;
if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
  NewId = listofNumbers.filter((Temp) => Temp !== value);
  setListofNumbers(NewId);
} else {
  setListofNumbers([...listofNumbers, value]);
}
console.log("sss", listofNumbers);
};

const selectMultipleFunction = (e) => {
if (e.target.checked) {
  console.log("if List", fullList);
  setListofNumbers(fullList);
} else {
  console.log("else List", fullList);
  setListofNumbers([]);
}
};

useEffect(() => {
let tempArr = [];
data &&
  data.forEach((i) => {
    console.log("I", i);
    tempArr.push(i?.id);
  });
setFullList(tempArr);
}, [data]);

const [valueOfSearch,setValuesofSearch] = useState("")
function searchFunction(e) {


setValuesofSearch(e?.target?.value)
setParams({ ...params, search: e?.target?.value, page:1 });
setPage(1)
}




return (
<>
<ClientManagementLayout 
  setOpen={setShowImportModal}
  searchFun={searchFunction}

    getData={getData}
    isCard={false}
    isFilter={filter}
     newfilter={true}
    setFilterOpen={setShowFilterDialog}
    ClearFilter={clearFilter}
    CreateAccess={GetAccess("customers_create")}
    ImportAccess={GetAccess("customers_create")}
    ExportAccess={GetAccess("customers_create")}
    officeId={officeId}
    searchValue={valueOfSearch}
    setViewMode={setViewMode}
    neededSearch={true}
    viewMode={viewMode}
    setOpenExport={setShowExport}
    // handleSearch={handleSearch}
    >
          {
screenSize.width <= "786" ?(<>
<div className=' w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
<MobileSRIndex
data={data}
total={totalCount}
pageIndex={page}
setPageIndex={setPage}
dataCount={pageCount}
setDataCount={setPageCount}
officeId={officeId}
getData={getData}

/>
</div>
</>):(<>
<div className="w-full h-full ">
  
  {/* {viewMode === "list" ? ( */}
    <CustomDataTable
      fetcher={getData}
      data={data}
      availableHeaders={availableHeaders}
      defaultHeader={defaultHeader}
      bodyHeight="max-h-[calc(100vh-260px)]"
      height="h-[calc(100vh-160px)]"
      total={totalCount}
      pageIndex={params.page}
      setPageIndex={setPage}
      dataCount={params.per_page}
      setDataCount={setPageCount}
      storageName="SurveyReportTable"
        editAccess="SurveyReport_edit"
      deteleAccess="SurveyReport_delete"
      dataLoading={dataLoading}
      searchQuery={params?.search != "" ? params?.search : ""}
      hasMultiEdit={true}
      selectOneFunction={selectOneFunction}
      setShowEdit={setShowEdit}
      showEdit={showEdit}
      listofNumbers={listofNumbers}
      selectMultipleFunction={selectMultipleFunction}
      fullList={fullList}
      getById="id"
    />
  {/* ) : (
    <>
      <div className="w-full h-[calc(100vh-190px)] rounded-md bg-white p-3 mt-4 relative overflow-y-scroll">
        <div className="flex gap-40">
          <p className="text-xs font-semibold text-[#111537] text-left">
            Survey Report : {totalCount}
          </p>
        </div>
        <div className="w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4">
          {dummyData &&
            dummyData.map((item, idx) => (
              <SurveyReportCard fetcher={getData} item={item} key={idx} />
            ))}
        </div>
      </div>
      <div className="w-full h-[40px] rounded-b-md bg-white">
        <Pagination
          total={totalCount}
          pageIndex={page}
          setPageIndex={setPage}
          dataCount={pageCount}
          setDataCount={setPageCount}
        />
      </div>
    </>
  )} */}
  </div>
  </>)}
  </ClientManagementLayout>
 
  {showFilterDialog && (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
        <h2 className="text-xl mb-4">Filter </h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="flex flex-col mb-4">
               <div className="flex justify-between  w-full ">
                              <NuDate
                               label="From "
                               placeholder="dd/mm/yyyy"
                               formik={formik}
                               name="dateFrom"
                               width="w-full"
                             />
                              <NuDate
                               label="To "
                               placeholder="dd/mm/yyyy"
                               formik={formik}
                               name="dateTo"
                               width="w-full"
                             />
                             
                             </div>

                             {/* <MultiSelect
                                           label="Assignee"
                                           Options={user}
                                           formik={formik}
                                           placeholder="Choose"
                                           name="assigneeId"
                                           isRequired={true}
                                           width="w-full"
                                            FixPosition={true}
                                            PortalTarget={false}
                                         /> */}

<FormikSelectTwo
                type="text"
                label="Status"
                placeholder="Status"
                Options={status}
                formik={formik}
                name="status"
                width="w-full"
                displayProperty={"Status"}
              propertyName={"Status_Survey"}
              getFunc={refStatus}

                
              />
              </div>
          <div className="flex justify-end gap-2">
            <CancelButton handleClick={closeFilterDialog} />
            <SubmitButton name="Apply" />
          </div>
        </form>
      </div>
    </div>
  )}

  {showEdit && (
    <MultiEditSR
      data={listofNumbers}
      getData={getData}
      onClose={() => setShowEdit(false)}
    />
  )}
  {showImportModal && (
    <ImportSurveyReport
      show={showImportModal}
      onClose={closeModal}
      getData={getData}
    />
  )}
  {showExport && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
              <div className=" w-full flex justify-between items-center  bg-white">
                <h2 className=" text-sm 2xl:text-base font-medium ">
                  Export Data
                </h2>
                <div
                  className=" cursor-pointer "
                  onClick={() => setShowExport(false)}
                >
                  <CloseIcon />
                </div>
              </div>
              <form onSubmit={ExportFormik.handleSubmit}>
                <div className=" w-full flex flex-wrap">
                  <div className=" w-full flex ">
                    <div className=" w-1/2 flex items-center px-6 py-3 ">
                      <input
                        id="default-radio-1"
                        type="radio"
                        value="all"
                        name="type"
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                        onChange={ExportFormik.handleChange}
                        checked={ExportFormik.values.type =="all"}
                      />
                      <label
                        htmlFor="default-radio-1"
                        className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                      >
                        All Data
                      </label>
                    </div>
  
                    <div className="w-1/2 flex items-center px-6 py-3">
                      <input
                        id="default-radio-2"
                        type="radio"
                        value="filter"
                        name="type"
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                        onChange={ExportFormik.handleChange}
                        checked={ExportFormik.values.type == "filter"}
                      />
                      <label
                        htmlFor="default-radio-2"
                        className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                      >
                        Filter Data
                      </label>
                    </div>
                  </div>
                  {ExportFormik.values.type === "filter" && (
                    <>
                           <div className="flex justify-between  w-full ">
                              <NuDate
                               label="From "
                               placeholder="dd/mm/yyyy"
                               formik={formik}
                               name="dateFrom"
                               width="w-full"
                             />
                              <NuDate
                               label="To "
                               placeholder="dd/mm/yyyy"
                               formik={formik}
                               name="dateTo"
                               width="w-full"
                             />
                             
                             </div>

                             {/* <MultiSelect
                                           label="Assignee"
                                           Options={user}
                                           formik={formik}
                                           placeholder="Choose"
                                           name="assigneeId"
                                           isRequired={true}                     
                                           width="w-full"
                                            FixPosition={true}
                                           PortalTarget={false}
                                         /> */}

<FormikSelectTwo
                label="Status"
                placeholder="Status"
                Options={status}
                formik={formik}
                name="status"
                width="w-full"
                displayProperty={"Status"}
              propertyName={"Status_Survey"}
              getFunc={refStatus}

                
              />
         
                    </>
                  )}
                  <div className="flex w-full justify-end gap-2">
                    <CancelButton handleClick={closeFilterDialogebox} />
                    <SubmitButton name="Export" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

</>
);
}
export default SurveyReportIndex;